// Values double as CSS class names in header-bar-presence.component (see the `.scss`), so keep them in sync.
export enum HeaderBarStatusIndicator {
  Rona = 'rona',
  Acw = 'acw',
  Ready = 'ready',
  NotReady = 'notReady',
}
